/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
 */

import config from '@/config';
import { FEATURE_SESSION_TEMPLATES } from '@/constants/features.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.sessionTemplates.list],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_SESSION_TEMPLATES),
            getPermissionsGuard([{ resource: 'portal.session-template', scopes: ['view'] }])
        ]),
        controller: () => import('./controllers/sessionTemplates')
    },
    {
        path: [config.routes.sessionTemplates.edit],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_SESSION_TEMPLATES),
            getPermissionsGuard([{ resource: 'portal.session-template', scopes: ['edit'] }])
        ]),
        controller: () => import('./controllers/sessionTemplate')
    },
    {
        path: [config.routes.sessionTemplates.create],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_SESSION_TEMPLATES),
            getPermissionsGuard([{ resource: 'portal.session-template', scopes: ['create'] }])
        ]),
        controller: () => import('./controllers/sessionTemplate')
    }
];
